export const MACHINE_COUNT = 20;

export function machineLabel(winner) {
  if (!winner || !(Number(winner.confId) > 0)) return "";
  return String(winner.machine ?? winner.confId).trim() || String(winner.confId);
}

// The API has no physical floor coordinates. These slots represent participants,
// not their real cabinet locations, and never determine the draw's outcome.
export function mapMachines(participants = [], winner = null) {
  const labels = [
    ...new Set(participants.map((entry) => String(entry.machineName ?? "").trim()).filter(Boolean)),
  ].slice(0, MACHINE_COUNT);
  while (labels.length < MACHINE_COUNT) labels.push("");
  const winningLabel = machineLabel(winner);
  let winnerIndex = winningLabel ? labels.indexOf(winningLabel) : -1;
  if (winningLabel && winnerIndex < 0) {
    let hash = 0;
    for (const char of winningLabel) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
    winnerIndex = hash % MACHINE_COUNT;
    labels[winnerIndex] = winningLabel;
  }
  return { labels, winnerIndex };
}
